export default __webpack_public_path__ + "87d728d6bf2c22501969f40eafe82c52.png";